import { Api } from '@fnv-core/http';
import { addQueryParameters } from '@fnv-core/utils';

const INPUT_DEBOUNCE_MILLISECONDS = 300;
const AUTOCOMPLETE_MINIMUM_LENGTH = 3;

interface IAutocompleteItem {
  /**
   * The autocompletes string with the highlighted part.
   * 
   * @example
   * auto<b>complete</b>
   */
  Key: string;
  /**
   * The autocompleted string;
   */
  Value: string;
}

export function InitAutocomplete() {

  function debounce(func: Function, timeout = INPUT_DEBOUNCE_MILLISECONDS) {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  const inputs = Array.from(document.getElementsByClassName('autocomplete-enabled'));

  inputs.forEach(inpt => {
    inpt.addEventListener('input', (event) => {
      triggerAutocomplete(event);
    });
    return;
  });

  window.onclick = (event: MouseEvent & { target: Element }) => {
    if (!event.target.matches('.autocomplete__item')) {
      const containers = Array.from(document.getElementsByClassName('autocomplete-container'));

      containers.forEach(container => {
        container.innerHTML = '';
      });

      return;
    }

    const value = event.target.getAttribute('data-value');
    const form = event.target.closest('form');
    const input = form.getElementsByClassName('autocomplete-enabled')[0] as HTMLInputElement;
    if (input != null) {

      let searchString = input.value;

      const splittedValue = value.trim().split(' ');
      if (splittedValue.length > 1) {

        input.value = value;

      } else {

        const splitted = searchString.trim().split(' ');
        splitted[splitted.length - 1] = value;

        input.value = splitted.join(' ');

      }

      $(input).trigger('input');

      if ($(".pagebuilder__widget-zoekbalk").length > 0) {

        const url = $(form).attr("data-url");
        if (url !== undefined) {
          location.href = url + "?search=" + input.value;
        }

      }

    }
    const list = event.target.parentElement;
    list.remove();

  };

  const triggerAutocomplete = debounce((event: Event) => doAutocomplete(event));

  async function doAutocomplete(event: Event) {

    const target = event.target;
    if (!(target instanceof HTMLInputElement)) {
      return;
    }

    const form = target.closest('form');
    const element = form.getElementsByClassName('autocomplete-container')[0];

    if (element == null) {
      return;
    }

    element.innerHTML = '';

    const inputTarget = target as HTMLInputElement;
    const autocompleteValue = inputTarget.value;

    if (autocompleteValue.trim().length < AUTOCOMPLETE_MINIMUM_LENGTH) {
      return;
    }

    const ul = document.createElement('ul');
    ul.classList.add('dropdown-menu');
    ul.classList.add('autocomplete__list');

    const searchString = inputTarget.value.trim();
    const autocompleteUrl = target.getAttribute('data-autocomplete-url');

    const url = addQueryParameters(autocompleteUrl, [{ key: 'search', value: searchString }]);

    const results = await Api.get<IAutocompleteItem[]>(url);

    if (results.length !== 0) {
      results.forEach(result => {
        const li = document.createElement('li');
        li.setAttribute('data-value', result.Value);
        li.innerHTML = result.Key;
        li.classList.add('autocomplete__item');
        li.classList.add('dropdown-item');

        ul.appendChild(li);
      });

      ul.classList.add('d-block');
      element.appendChild(ul);
    }
  }
}
